import { LOCATION_NAME_TAKEN_MARKER } from '@threadheads/shared';
import { markedFieldMessage } from './markedFieldError';

/**
 * The sentence to show under the Name field when a create or rename hit the
 * "one location name per organization" rule, otherwise null.
 */
export const locationNameTakenMessage = (error: unknown) =>
  markedFieldMessage(error, LOCATION_NAME_TAKEN_MARKER);
